import LoadAttachments from "./LoadAttachments";

export default LoadAttachments;